export default __webpack_public_path__ + "static/media/notification-active.b56086ee.svg";